import { ErrorRetry, Spinner } from '@brush/ui';
import type { ReactNode } from 'react';

/**
 * Loading and failure gate for one area.
 *
 * Each area passes only the queries it actually reads, which is the point of splitting the
 * console up: opening Settings waits on platform settings alone, not on every tournament on
 * the platform.
 */
interface Gateable {
  isLoading: boolean;
  isError: boolean;
  refetch: () => unknown;
}

export function AreaGate({
  queries,
  loadingLabel,
  errorMessage,
  children,
}: {
  queries: Gateable[];
  loadingLabel: string;
  errorMessage: string;
  children: ReactNode;
}) {
  if (queries.some((q) => q.isLoading)) return <Spinner label={loadingLabel} />;
  if (queries.some((q) => q.isError)) {
    return (
      <ErrorRetry
        message={errorMessage}
        onRetry={() => queries.forEach((q) => void q.refetch())}
      />
    );
  }
  return <>{children}</>;
}
